import React, { useContext } from 'react'
import Modal from 'react-bootstrap/Modal'
import styled from 'styled-components'
import { JazeelContext } from '../../utils/JazeelContext'
import ShareBody from './ShareBody'

const ModalBody = styled(Modal.Body)`
  height: 28.125em;
  overflow-y: auto;
`
const ModalTitle = styled(Modal.Title)`
  font-size: 2.5em;
  font-weight: bold;
  text-align: center;
  margin-left: 30%;
  color: #212529;
`
const HeaderDescription = styled.div`
  text-align: center;
  margin-top: 0.7em;
`

export default function ShareModal(props) {
  const { events, makeTitle } = useContext(JazeelContext)
  console.log('testevents:', events)

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <ModalTitle>Share and earn!</ModalTitle>
      </Modal.Header>
      <HeaderDescription>
        Get more points with each share and exchange it with amazing rewards
      </HeaderDescription>
      <ModalBody>
        <div>
          {events
            ? events.map(event => (
                <ShareBody
                  event={event}
                  makeTitle={makeTitle}
                  key={event.event_slug}
                />
              ))
            : ''}
        </div>
      </ModalBody>
    </Modal>
  )
}
